/**
 * Моковые данные для метрик робоэдвайзера
 * Используются пока данные с бэка не приходят
 */
export const mockRoboMetrics = {
  returnSinceInception: {
    value: '54 057.50 ₽',
    percent: '+9.4%'
  },
  returnYesterday: {
    value: '1 250.00 ₽',
    percent: '+0.2%'
  },
  assetValue: '627 500 ₽',
  profit: '+54 057.50 ₽',
  trackingError: '0.5%'
};

// Для компонента AssetValueProfit
export const mockMetrics = {
  assetValue: '627 500 ₽',
  profit: '+54 057.50 ₽'
};


